// Small shared validators used across every drawer's save flow.
// Each returns null on success, or a Thai/English error message on failure.
// Empty values are treated as "not provided" — only validate when there's something to check.

const PHONE_RE = /^\d{10}$/
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

/**
 * Validate a phone number. Must be exactly 10 digits. Empty / null skipped.
 * @param {string|null|undefined} value
 * @param {string} [label] — field name for the error message
 */
export function validatePhone(value, label = 'Phone') {
  const v = (value || '').trim()
  if (!v) return null
  return PHONE_RE.test(v) ? null : `${label} must be exactly 10 digits.`
}

/**
 * Validate an email address. Empty / null skipped.
 * @param {string|null|undefined} value
 * @param {string} [label]
 */
export function validateEmail(value, label = 'Email') {
  const v = (value || '').trim()
  if (!v) return null
  return EMAIL_RE.test(v) ? null : `${label} must be a valid email address.`
}

/**
 * Run several validators and return the first non-null error (or null).
 * Use to keep save handlers readable:
 *   const err = firstError(
 *     validatePhone(form.phone),
 *     validateEmail(form.email, 'Lead email'),
 *   )
 *   if (err) { setErr(err); return }
 */
export function firstError(...results) {
  return results.find((r) => r) || null
}
